class TrfCollectionButtons extends HTMLElement {
  constructor() {
    super();
    this.elCollectionButtons = this.querySelectorAll('trf-collection-buttons .btn');
  }

  connectedCallback() {
    document.addEventListener('trf-filter-applied', this.activateButtons.bind(this));

    this.activateButtons();
  }

  activateButtons() {
    const currentURL = new URL(window.location.href);
    const currentParams = new URLSearchParams(currentURL.search);

    for (const elCollectionButton of this.elCollectionButtons) {
      const buttonURL = new URL(elCollectionButton.href);

      if (currentURL.pathname !== buttonURL.pathname) continue;

      const buttonParams = new URLSearchParams(buttonURL.search);
      if (!buttonParams) continue;

      let shouldActivate = true;

      for (const [key, value] of buttonParams.entries()) {
        const currentValues = currentParams.getAll(key);

        if (!currentValues.includes(value)) {
          shouldActivate = false;
          break;
        }
      }

      this.toggleActive(elCollectionButton, shouldActivate);
    }
  }

  toggleActive(elButton, shouldActivate) {
    elButton.classList.toggle('active', shouldActivate);
  }
}

if (!customElements.get('trf-collection-buttons')) {
  customElements.define('trf-collection-buttons', TrfCollectionButtons);
}
